export default function toUpperCase(text) {
    return text.toUpperCase();
}